/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  StoreProfileImageMetaData,
} from '../models/index';
import {
    StoreProfileImageMetaDataFromJSON,
    StoreProfileImageMetaDataToJSON,
} from '../models/index';

export interface DownloadStoreProfileImageRequest {
    uuidWithFileending: string;
}

export interface UploadStoreProfileImageRequest {
    file: Blob;
}

/**
 * 
 */
export class StoreProfileImageResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for downloadStoreProfileImage without sending the request
     */
    async downloadStoreProfileImageRequestOpts(requestParameters: DownloadStoreProfileImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uuidWithFileending'] == null) {
            throw new runtime.RequiredError(
                'uuidWithFileending',
                'Required parameter "uuidWithFileending" was null or undefined when calling downloadStoreProfileImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/store-profile/image/{uuidWithFileending}`;
        urlPath = urlPath.replace(`{${"uuidWithFileending"}}`, encodeURIComponent(String(requestParameters['uuidWithFileending'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async downloadStoreProfileImageRaw(requestParameters: DownloadStoreProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.downloadStoreProfileImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async downloadStoreProfileImage(requestParameters: DownloadStoreProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.downloadStoreProfileImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadStoreProfileImage without sending the request
     */
    async uploadStoreProfileImageRequestOpts(requestParameters: UploadStoreProfileImageRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadStoreProfileImage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }


        let urlPath = `/api/v1/ui/store-profile/image`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
    }

    /**
     */
    async uploadStoreProfileImageRaw(requestParameters: UploadStoreProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StoreProfileImageMetaData>> {
        const requestOptions = await this.uploadStoreProfileImageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StoreProfileImageMetaDataFromJSON(jsonValue));
    }

    /**
     */
    async uploadStoreProfileImage(requestParameters: UploadStoreProfileImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StoreProfileImageMetaData> {
        const response = await this.uploadStoreProfileImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
